<template>
  <HeadlineComponent>Neues Crewmitglied</HeadlineComponent>
  <Form class="form-horizontal" @submit="onSubmit" :initialValues="{food_preferences: 2}">
    <p>Du musst alle Felder ausfüllen!</p>
    <UserForm pw-rules="required" admin-registration="true"></UserForm>
    <div class="form-group">
      <div class="form-check">
        <Field type="checkbox" name="allow_multiple_shifts" class="form-check-input" :value="true"/>
        <label class="form-check-label" for="allow_multiple_shifts">
          Crewmitglied kann mehr als eine Schicht zur gleichen Zeit belegen
        </label>
      </div>
    </div>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading">Anlegen</LoadingButton>
    </div>
  </Form>
</template>

<script>
import {defineComponent} from "vue";
import router from "@/router";
import {useUserStore} from "@/stores/user";
import {mapActions} from "pinia";
import {useAlertsStore} from "@/stores/alerts";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import {Form, Field} from "vee-validate";
import userService from "@/services/user.service.js";
import UserForm from "@/components/UserForm.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { useConfigStore } from "@/stores/config";
import { setErrors } from '@/helper/ErrorToActions.js';
import * as Sentry from '@sentry/vue';

export default defineComponent({
  name: 'CreateUserView',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {LoadingButton, UserForm, HeadlineComponent, Form, Field},
  data(){
    return {
      loading: false
    }
  },
  async mounted() {
    await useConfigStore().get();
  },
  methods: {
    ...mapActions(useUserStore, {setUser: 'set'}),
    ...mapActions(useAlertsStore, {addAlert: 'add'}),
    async onSubmit(values, actions) {
      this.loading = true
      // check if form is valid...
      try {
        let response = await userService.create(values)
        if(response.data.success) {
          this.addAlert('success', response.data.message);
          router.push({path: '/user'})
        } else {
          this.addAlert('danger', response.data.message);
        }
        window.scrollTo(0, 0)
      } catch (e) {
        if(e) {
          if(e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions)
            return
          }
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false
    }
  },
})

</script>

<style scoped>
@media (max-width: 575px){
  form {
    width: 100%;
    max-width: 330px;
    margin: 0 auto;
    padding: 15px;
  }
  .form-group {
    text-align: center;
  }
}

</style>